// extracted by mini-css-extract-plugin
module.exports = {"con":"style_con__9wQmh","imgCon":"style_imgCon__7eMVC","img":"style_img__cQk_S","content":"style_content__HbRVS","bio":"style_bio__IRJTi","name":"style_name__6vY3y"};